// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3P51R","footer":"styles_footer__3h5Dn","passCodeTooltip":"styles_passCodeTooltip__1zyyX"};